import { Box, Flex } from '@cowsquare/design';
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import ErrorIcon from '../../../asset/icon-error-web.svg';

const CardBox = styled(Box).attrs({
  my: ['100px', '150px'],
})``;

const Title = styled(Box)`
  font-family: OpenSans;
  font-size: ${themeGet('fontSizes.h1')};
  font-weight: ${themeGet('fontWeights.semibold')};
  line-height: normal;
  color: ${themeGet('colors.primaryDark')};
`;

const SubTitle = styled(Box)`
  font-family: OpenSans;
  font-size: ${themeGet('fontSizes.h4')};
  line-height: 1.5;
  color: ${themeGet('colors.primaryDark')};
`;

const IconBox = styled(Box)`
  width: 160px;
  height: 160px;
`;

const ErrorPage = ({ status }) => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <CardBox>
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
          <IconBox>
            <img src={ErrorIcon} alt="" />
          </IconBox>
          <Title mb={10}>{status} Error</Title>
          <SubTitle>Internal Server Error.</SubTitle>
        </Flex>
      </CardBox>
    </Flex>
  );
};

export default ErrorPage;
